export const featureFlagsConfig = [
    'expert_services_intelligent_briefs',
    'design_services_holiday_hub',
    'design_services_sdp_inclusions',
    'design_services_hub_page_trust_signal',
    'design_services_pro_logo_to_requests',
] as const;
